// extracted by mini-css-extract-plugin
module.exports = {"menuIconContainer":"cn_menuIconContainer__2jeGd","menuIcon":"cn_menuIcon__N6ahG","menuIcon_d":"cn_menuIcon_d__3mnVf","sparkEffect":"cn_sparkEffect__1LQZa"};